import React from "react";
import { styled } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import TextView from "../../TextView";
import IyugaTooltip, { StyledTooltip } from "../../IyugaTooltip";
import { colors } from "../../../utils";

// Custom styled Radio component
const CustomRadio = styled(Radio)(({ theme }) => ({
  "& .MuiSvgIcon-root": {
    fontSize: "20px",
  },
  color: colors.PrimaryPurple300,
  "&.Mui-checked": {
    color: colors.PrimaryPurple500,
  },
}));

const CustomFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  margin: "0 8px 0 -11px",
  "& .MuiFormControlLabel-label": {
    color: colors.black,
    fontSize: "14px",
    fontFamily: "DM Sans, sans-serif",
  },
}));

const CustomRadioButton = ({
  label,
  options,
  selectedOption,
  onChange,
  orientation,
  style,
}) => {
  return (
    <Box style={{ marginBottom: 20, ...style }}>
      <FormControl component="fieldset">
        <Box display="flex" alignItems="center" style={{ marginBottom: 10 }}>
          <TextView variant="subtitle">{label}</TextView>
        </Box>
        <RadioGroup
          aria-label="custom-radio-buttons"
          name="custom-radio-buttons"
          value={selectedOption}
          onChange={onChange}
          row={orientation === "horizontal"}
        >
          {options.map((option, index) => (
            <Box
              key={index}
              display="flex"
              flexDirection="row"
              alignItems="center"
            >
              <CustomFormControlLabel
                value={option.value}
                control={<CustomRadio disabled={option.disabled} />}
                label={
                  <Box display="flex" alignItems="center">
                    <span>{option.label}</span>
                    {option.icon && option.iconTooltip ? (
                      <StyledTooltip 
                        title={option.iconTooltip || ''} 
                        arrow placement="bottom"
                        color={"#325AE9"}
                        textColor={"#fff"}
                      >
                        <img 
                          src={option.icon} 
                          alt={option.label}
                          style={{ 
                            marginLeft: '8px',
                            width: '20px',
                            height: '20px',
                            objectFit: 'contain'
                          }} 
                      />
                      </StyledTooltip>
                    )
                    : option.icon ? (
                      <img 
                        src={option.icon} 
                        alt={option.label}
                        style={{ 
                          marginLeft: '8px',
                          width: '20px',
                          height: '20px',
                          objectFit: 'contain'
                        }} 
                      />
                    ) : null
                  }
                  </Box>
                }
              />
              {option.tooltip && (
                <IyugaTooltip tooltip={option.tooltip} placement="right" />
              )}
            </Box>
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default CustomRadioButton;
